export default {
    meta: {
        title: '标准版-选址地图定位页'
    }
};
